import { ModuleSelectionsDetailTranslation } from 'locales/de/pages/AWPM-FWPM/moduleSelectionsDetail';

const en: ModuleSelectionsDetailTranslation = {
  failedLoading: 'Failed to load module selection',
  filter: {
    search: 'Search...',
    completed: 'State',
    courseOfStudy: 'Courses of study',
    takesPlace: 'Takes place',
    options: {
      takesPlace: 'Takes place',
      takesNotPlace: 'Does not take place',
      complete: 'Complete',
      incomplete: 'Incomplete'
    }
  },
  sort: {
    nameAsc: 'Name ascending',
    nameDesc: 'Name descending'
  },
  modulePreview: {
    tabTitle: 'Selection overview',
    addSelectionModuleTitle: 'Add Module',
    startSelection: 'Start Selection',
    publishSelection: 'Publish selection results',
    archiveSelection: 'Archive selection',
    startSelectionError: `There must be at least one assigned module to the selection, all modules must be complete and the selection must have started.`,
    publishSelectionError:
      'The status of the selection must be in the move-up procedure and the selection must not have already been published.',
    startEmailNotificationError: {
      alreadyNotified: 'The students have already been notified with the results of the selection',
      notYetPublished:
        'The selection has to be already published, in order to inform the students about the results of the selection.'
    },
    archiveSelectionError:
      'The status of the selection must be completed in order for the selection to be archived by an selection admin, or a secretariat staff member.',
    addModuleSelection: 'Add Module',
    modulesTitle: 'Modules',
    selectionState: 'Selection State',
    noItems: 'No Modules found',
    confirm: {
      finalSelectionTitle: 'Start the final calculation of the selection',
      finalSelectionBody:
        'Are you sure you want to start the final calculation of the selection? This ends the selection phase and the move-up phase begins.',
      publishSelectionTitle: 'Publication of selection results',
      publishSelectionBody:
        'Students are informed about the publication of the selection results via the dashboard notification (in the notification bell).\n No e-mail notifications are sent at this time, not even if participant lists are edited by an administrator.\n If students move up from the waiting list, are deleted from a module or added to a module, no notification is triggered either.\n\n Would you like to publish the election results now?',
      archiveSelectionTitle: 'Archive selection',
      archiveSelectionBody:
        'Do you really want to archive the selection? With this the selection can no longer be edited.',
      startEmailNotificationTitle: 'Start Email-Notification for Selection: "{{title}}"',
      startEmailNotificationBody:
        'All students participating in the election will now be informed about the current election results.\n\n This means that they will be informed directly via e-mail about moving up, adding or deleting in a module.\n\n Would you like to start the e-mail notification and inform all participating students about the current status of the election?'
    },
    success: {
      publishSelection: 'The selection results were successfully published.',
      archiveSelection: 'The selection was successfully archived.',
      sendEmailNotification:
        'The students have successfully been notified about the results of the selection.'
    },
    error: {
      publishSelection: 'The selection results could not be published.',
      archiveSelection: 'The selection could not be archived.',
      sendEmailNotification:
        'The students could not be notified about the results of the selection.'
    },
    buttons: {
      edit: 'Edit',
      delete: 'Delete',
      template: 'Use as template'
    },
    information: {
      title: 'Selection information',
      dischargeByStudentsUntil: 'Dischargable by students:',
      until: 'Until',
      contentVisibleFrom: 'Content visible from:',
      activeInAllCommunities: 'Active in all Communities',
      publishedAt: `Results published at:`,
      generalInfo: 'General Information',
      electionTips: 'Selection Tips',
      create: {
        alerts: { saveFailed: 'Failed to add modules' },
        invalidError: 'Please select at least one Modul'
      }
    },
    explanatoryLegendText: 'Modules that have been canceled and will therefore not take place.',
    create: {
      addedModules: 'Selected Modules:',
      selectModules: 'Select Modules:',
      selectAllModules: 'Select all Modules',
      modulePreferences: 'Choosen Modules:',
      noItemsSelected: 'No Modules selected',
      noItems: 'No module templates found',
      alerts: { saveFailed: 'Failed to add modules' },
      steps: {
        selectModules: 'Modules selection',
        confirmation: 'Review & Add'
      },
      selectModulesField: 'Selected Modules',
      invalidError: 'Please select at least one Modul'
    },
    deleteModuleSelection: 'Delete Selection',
    deleteModuleSelectionDescription:
      'Are you sure you want to delete this selection? This process can not be reverted.'
  },
  occupancy: { tabTitle: 'Module occupancy' },
  studentList: {
    tabTitle: 'Student occupancy',
    table: {
      mtrNumber: 'Matriculation number',
      lastName: 'Last name',
      firstName: 'First name',
      courseOfStudy: 'Course of study',
      semester: 'Semester',
      modulePreferences: 'Desired modules',
      desiredNumberOfModules: 'Desired quantity',
      lotteryResult: 'Received Modules',
      studentHasBeenRemoved: 'Student has been removed from the module'
    },
    filter: {
      studentsWithInsufficientModules: 'Students with insufficient modules'
    },
    export: {
      exportAllStudents: 'Export all students',
      exportAllStudentsWithoutModules:
        'Export all students who have not received their desired number of modules.'
    }
  }
};

export default en;
